import { makeStyles } from 'e100-react-components';
import {
  CONTROLS_Z_INDEX,
  INNER_PADDING
} from 'common/constants/styles';

import betaLabel from './betaLabel.svg';

export const useStyles = makeStyles(({
  spacing,
  palette
}) => ({
  container: {
    display: 'inline-block',
    position: 'fixed',
    bottom: spacing(INNER_PADDING),
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: CONTROLS_Z_INDEX
  },
  divider: {
    height: spacing(5)
  },
  buttonLabel: {
    textTransform: 'none'
  },
  activeButton: {
    backgroundColor: palette.primary.light,
    '&:hover': {
      backgroundColor: palette.primary.light,
      cursor: 'default'
    }
  },
  firstButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    lineHeight: 0,
    minWidth: spacing(13),
    textTransform: 'none'
  },
  secondButton: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    lineHeight: 0,
    minWidth: spacing(13),
    textTransform: 'none',
    '&:after': {
      content: '""',
      position: 'absolute',
      backgroundImage: `url(${betaLabel})`,
      right: -6,
      top: -6,
      width: spacing(3),
      height: spacing(3),
    }
  }
}));